export default __webpack_public_path__ + "fcdf14841cd468de3f43704be16fa303.png";